<template>
	<Dialog
		:dialog-visible="visible"
		:title="dialogTitle"
		:message="dialogMessage"
		:agree-text="dialogAgreeText"
		:cancel-text="dialogCancelText"
		:persistent-dialog="true"
		:custom-outside-click-function="ignoreOutsideClick"
		@agree="handleAgree"
		@cancel="logout">
	</Dialog>
</template>

<script>
	import Dialog from "./Dialog.vue";

	// API error messages are plain text — escape all HTML before Dialog.vue renders them via v-html.
	function escapeHtml(str) {
		return String(str)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}

	export default {
		name: "NoAccount",
		components: {
			Dialog
		},
		data() {
			return {
				visible: false,
				reason: "no_account",
				customMessage: "",
				supportEmail: window.env.VITE_SUPPORT_EMAIL,
				trialpageUrl: window.env.VITE_TRIAL_PAGE_URL
			};
		},
		computed: {
			isOrgAccessLost() {
				return this.reason === "org_access_lost";
			},
			dialogTitle() {
				return this.isOrgAccessLost ? "Organization Access Changed" : "No Account Found";
			},
			dialogMessage() {
				if (this.customMessage) {
					return this.customMessage;
				}
				if (this.isOrgAccessLost) {
					return "You no longer have access to this organization. You may have been removed, or the organization may no longer exist. If you belong to another organization, try logging in again.";
				}
				return `We're sorry, but there is no LiveSwitch account associated with this email.  Please try logging in with different credentials, creating a free trial, or contact the organization administrator for your organization.  You can also reach the LiveSwitch team at ${this.supportEmail}, and we'd be happy to assist.`;
			},
			dialogAgreeText() {
				return this.isOrgAccessLost ? "Log In Again" : "Start a Free Trial";
			},
			dialogCancelText() {
				return this.isOrgAccessLost ? "Log Out" : "Try a Different Email";
			}
		},
		methods: {
			open(reason, message) {
				this.reason = reason || "no_account";
				this.customMessage = typeof message === "string" && message ? escapeHtml(message) : "";
				this.visible = true;
			},
			logout() {
				this.visible = false;
				this.$auth.logout({
					returnTo: window.location.protocol + "//" + window.location.host + "/logout"
				});
			},
			handleAgree() {
				if (this.isOrgAccessLost) {
					this.relogin();
				} else {
					this.redirectToTrialPage();
				}
			},
			async relogin() {
				this.visible = false;
				// EXPLICIT: the user pressed "Log In Again" in this dialog (LSP-17342).
				await this.$auth.login(
					{
						path: "/"
					},
					true,
					null,
					{},
					{ isExplicitUserIntent: true }
				);
			},
			redirectToTrialPage() {
				this.visible = false;
				window.location.href = this.trialpageUrl;
			},
			ignoreOutsideClick() {
				// Do nothing on outside click
			}
		}
	};
</script>
